import React from 'react'
import useWindowDimensions from '../../hooks/useWindowDimensions'

export interface IValueRow {
  key: string
  value: string | number
}

interface IProps {
  label: string
  rows?: IValueRow[]
  onClick: () => void
}

const MobileResultHead = ({ label, rows, onClick }: IProps) => {
  const { width } = useWindowDimensions()

  if (width > 767) {
    return <></>
  }

  return (
    <div className='cs-md-4of12 csas-center mobile-result'>
      <button className='csas-blue-link flex' onClick={onClick}>
        <i className='icon icon--angle'></i>
        <span>{label}</span>
      </button>
      {rows && rows.length > 0 && (
        <div className='mobile-result__inputs'>
          {rows.map((row: IValueRow, index: number) => (
            <p key={index}>
              {row.key}: {row.value}
            </p>
          ))}
        </div>
      )}
    </div>
  )
}

export default MobileResultHead
